import AdminNav from "./AdminNav";
import AdminHeader from "./AdminHeader";
import { useGetCurrentUserQuery } from "../../../api/users";
import AdminMobileNav from "./AdminMobileNav";
import useIsMobile from "../../../hooks/useIsMobile";

const NavLayout = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useIsMobile();

  const {
    data: user,
    isLoading: isUserLoading,
    error: userError,
  } = useGetCurrentUserQuery();

  const isLoading = isUserLoading;
  const error = userError;

  if (isMobile) {
    return (
      <>
        <AdminMobileNav user={user} isLoading={isLoading} error={error} />
        {children}
      </>
    );
  }

  return (
    <>
      <AdminHeader user={user} isLoading={isLoading} error={error} />
      <AdminNav user={user} isLoading={isLoading} error={error} />
      {children}
    </>
  );
};

export default NavLayout;
